/**
 * Reporta errores de pantalla a la API: aparecen en el panel admin, sin mails.
 * Evita repetir el mismo error en bucle y nunca rompe la app si el reporte falla.
 */
const BASE = `${import.meta.env.VITE_API_URL ?? ''}/api/v1`;
const sent = new Map<string, number>();

export function reportClientError(error: unknown, context?: Record<string, unknown>): void {
  const err = error instanceof Error ? error : new Error(typeof error === 'string' ? error : 'Error desconocido');
  const key = `${err.name}:${err.message}`;
  const last = sent.get(key) ?? 0;
  if (Date.now() - last < 60_000) return;
  sent.set(key, Date.now());

  void fetch(`${BASE}/client-errors`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    keepalive: true,
    body: JSON.stringify({
      source: 'web',
      name: err.name,
      message: err.message.slice(0, 2000),
      stack: err.stack?.slice(0, 8000),
      route: window.location.pathname,
      release: import.meta.env.VITE_RELEASE || undefined,
      context,
    }),
  }).catch(() => undefined);
}

export function installGlobalErrorReporting(): void {
  window.addEventListener('error', (e) => reportClientError(e.error ?? e.message));
  window.addEventListener('unhandledrejection', (e) => reportClientError(e.reason));
}
